import React from 'react';

const IssueHistory = ({
  issues,
  dateFilter,
  onDateFilterChange,
  statusFilter,
  onStatusFilterChange,
  onRefresh,
  onShowDetails,
  onPrint,
}) => (
  <div style={{
    backgroundColor: 'var(--card-bg)',
    borderRadius: '4px',
    border: '1px solid var(--border)',
    padding: '0.5rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  }}>
    <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
      <input
        type="date"
        value={dateFilter}
        onChange={(e) => onDateFilterChange(e.target.value)}
        style={{
          flex: 1,
          padding: '6px 10px',
          fontSize: '12px',
          border: '1px solid var(--border)',
          borderRadius: '6px',
          backgroundColor: 'var(--card-bg)',
          color: 'var(--text)',
        }}
      />
      <select
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value)}
        style={{
          padding: '6px 10px',
          fontSize: '12px',
          border: '1px solid var(--border)',
          borderRadius: '6px',
          backgroundColor: 'var(--card-bg)',
          color: 'var(--text)',
        }}
      >
        <option value="all">Wszystkie</option>
        <option value="completed">Zako&#x144;czone</option>
        <option value="draft">Szkic</option>
      </select>
      <button
        onClick={onRefresh}
        style={{
          padding: '6px 12px',
          fontSize: '12px',
          border: '1px solid var(--text-muted)', color: 'var(--text-muted)' ,
          cursor: 'pointer',
        }}
      >
        &#x1F504;
      </button>
    </div>

    {issues.length === 0 ? (
      <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '1rem', fontSize: '11px' }}>
        Brak wyda&#x144; zewn&#x119;trznych w historii
      </div>
    ) : (
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {issues.map((issue) => (
          <div
            key={issue.id}
            style={{
              padding: '0.5rem',
              backgroundColor: 'var(--bg)',
              borderRadius: '4px',
              marginBottom: '0.4rem',
              border: '1px solid var(--border)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={{ fontWeight: '600', fontSize: '12px', color: 'var(--info)' }}>
                  {issue.document_number}
                </div>
                <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '2px' }}>
                  {new Date(issue.issue_date).toLocaleString('pl-PL')}
                </div>
                {issue.customer_name && (
                  <div style={{ fontSize: '10px', marginTop: '2px' }}>
                    &#x1F464; {issue.customer_name}
                  </div>
                )}
                <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '2px' }}>
                  &#x1F4E6; {issue.items_count} pozycji &bull;{' '}
                  {parseFloat(issue.total_amount || 0).toFixed(2)} z&#x142;
                </div>
                {issue.source_document && (
                  <div style={{ fontSize: '10px', color: 'var(--info)', marginTop: '2px' }}>
                    &#x1F517; {issue.source_document}
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', gap: '0.3rem' }}>
                <button
                  onClick={() => onShowDetails(issue)}
                  style={{
                    padding: '4px 10px',
                    fontSize: '11px',
                    border: '1px solid var(--info)', color: 'var(--info)' ,
                    cursor: 'pointer',
                  }}
                >
                  &#x1F441;&#xFE0F;
                </button>
                <button
                  onClick={() => onPrint(issue.id)}
                  style={{
                    padding: '4px 10px',
                    fontSize: '11px',
                    border: '1px solid var(--text-muted)', color: 'var(--text-muted)' ,
                    cursor: 'pointer',
                  }}
                >
                  &#x1F5A8;&#xFE0F;
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default IssueHistory;
